
import React, { useState, useEffect } from 'react';
import {
    Box, Container, Grid,
    Stack, Typography, FormControl,
    InputLabel, MenuItem, Select, Button,
    Dialog,
    DialogContent,
    DialogTitle,
    Table,
    TableContainer,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
} from '@mui/material';
import Paper from '@mui/material/Paper';
import { Card, CardContent } from 'semantic-ui-react';
import DialogBox from './DialogBox';


const Reports = () => {

    const [institutions, setInstitutions] = useState([]);
    const [selectedInstitution, setSelectedInstitution] = useState('');
    const [institutionIdMap, setInstitutionIdMap] = useState({}); // Store institution IDs in a map
    const [selectedInstitutionId, setSelectedInstitutionId] = useState('');
    const [isPopupOpen, setPopupOpen] = useState(false);

    const [isTableVisible, setTableVisible] = useState(true);
    const [isLineGraphVisible, setLineGraphVisible] = useState(false);
    const [publishedActivities, setPublishedActivities] = useState([]);
    const [unpublishedActivities, setUnpublishedActivities] = useState([]);
    const [communityOrgs, setCommunityOrgs] = useState([]);
    const [units, setUnits] = useState([]);
    const [programInitiatives, setProgramInitiatives] = useState([]);
    const [isPublishedDialogOpen, setPublishedDialogOpen] = useState(false);
    const [isUnpublishedDialogOpen, setUnpublishedDialogOpen] = useState(false);
    const [isCommunityOrgDialogOpen, setCommunityOrgDialogOpen] = useState(false);
    const [isUnitsDialogOpen, setUnitsDialogOpen] = useState(false);
    const [isProgramInitiativesDialogOpen, setProgramInitiativesDialogOpen] = useState(false);


    const toggleTable = () => {
        setTableVisible(true);
        setLineGraphVisible(false);
    };

    const toggleLineGraph = () => {
        setTableVisible(false);
        setLineGraphVisible(true);
    };


    useEffect(() => {
    // Fetch institutions when the component mounts
        fetch('/api/institutions') // Replace with the appropriate URL
            .then((response) => {

                if (!response.ok) {
                    throw new Error('Failed to fetch institutions');
                }

                return response.json();
            })
            .then((data) => {
                // Create a map of institution names to their IDs
                const idMap = {};
                data.forEach((institution) => {
                    idMap[institution.name] = institution.id;
                });

                // Store both the names and the ID map in the state
                setInstitutions(data.map(institution => institution.name));
                setInstitutionIdMap(idMap);
            })
            .catch((error) => {
                console.error('Error fetching institutions:', error);
            });
    }, []);

    const handleInstitutionChange = (e) => {
        const selectedName = e.target.value;
        setSelectedInstitution(selectedName);

        // Use the institutionIdMap to find the corresponding institution ID
        const selectedInstId = institutionIdMap[selectedName] || null;
        setSelectedInstitutionId(selectedInstId);
    };


    const handleCardClickPublishedActivities = () => {
    // Fetch published activities and update the state
        fetch(`/api/publishedactivities?selectedInstitutionId=${selectedInstitutionId}`)
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Failed to fetch published activities');
                }
                return response.json();
            })
            .then((data) => {
                // Add function call here to add missing data points
                const newdata = addMissingDataPoints(data);
                setPublishedActivities(newdata);
                setPublishedDialogOpen(true);
            })
            .catch((error) => {
                console.error('Error fetching published activities:', error);
            });
    };
    const handleCardClickUnPublishedActivities = () => {
    // Fetch unpublished activities and update the state
        fetch(`/api/unpublishedactivities?selectedInstitutionId=${selectedInstitutionId}`)
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Failed to fetch unpublished activities');
                }
                return response.json();
            })
            .then((data) => {
                const newdata = addMissingDataPoints(data);
                setUnpublishedActivities(newdata);
                setUnpublishedDialogOpen(true);
            })
            .catch((error) => {
                console.error('Error fetching unpublished activities:', error);
            });
    };

    const handleCardClickCommunityOrgs = () => {
    // Fetch unpublished activities and update the state
        fetch(`/api/communityorgs?selectedInstitutionId=${selectedInstitutionId}`)
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Failed to fetch community orgs');
                }
                return response.json();
            })
            .then((data) => {
                const newdata = addMissingDataPoints(data);
                setCommunityOrgs(newdata);
                setCommunityOrgDialogOpen(true);
            })
            .catch((error) => {
                console.error('Error fetching unpublished activities:', error);
            });
    };

    const handleCardClickUnits = () => {
    // Fetch unpublished activities and update the state
        fetch(`/api/units?selectedInstitutionId=${selectedInstitutionId}`)
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Failed to fetch units');
                }
                return response.json();
            })
            .then((data) => {
                console.log(data);
                const newdata = addMissingDataPoints(data);
                console.log(newdata);
                setUnits(newdata);
                setUnitsDialogOpen(true);
            })
            .catch((error) => {
                console.error('Error fetching Units:', error);
            });
    };


    const handleCardClickProgramInitiatives = () => {
    // Fetch unpublished activities and update the state
        fetch(`/api/programinitiatives?selectedInstitutionId=${selectedInstitutionId}`)
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Failed to fetch PI');
                }
                return response.json();
            })
            .then((data) => {
                const newdata = addMissingDataPoints(data);
                setUnits(newdata);
                setUnitsDialogOpen(true);
            })
            .catch((error) => {
                console.error('Error fetching PI:', error);
            });
    };


    const handleClosePopup = () => {
        setPopupOpen(false);
        // Close the dialog boxes
        setPublishedDialogOpen(false);
        setUnpublishedDialogOpen(false);
        setCommunityOrgDialogOpen(false);
        setUnitsDialogOpen(false);
        setProgramInitiativesDialogOpen(false);
    };

    const addMissingDataPoints = (data) => {
        const newData = [];
        let previousCumulativeCount = parseInt(data[0].cumulative_count);
        newData.push(data[0]);
        for (let i = 1; i < data.length; i++) {
            const currentRow = data[i];
            const currentYear = parseInt(currentRow.year);
            const currentMonth = parseInt(currentRow.month);


            // If this is not the first row, check for missing months

            const previousRow = data[i - 1];
            let previousYear = parseInt(previousRow.year);
            let previousMonth = parseInt(previousRow.month);


            // If there are missing months between this row and the previous row
            while (((currentYear > previousYear && previousMonth - currentMonth != 11) || (currentYear === previousYear && currentMonth > previousMonth + 1))
            ) {
                // Check if we've gone into the next year
                previousMonth++;
                if (previousMonth > 12) {
                    previousMonth = 1;
                    previousYear++;
                }
                // Add a new row with monthly count 0 and cumulative count equal to the previous row cumulative count
                newData.push({
                    year: previousYear.toString(),
                    month: previousMonth.toString(),
                    monthly_count: '0',
                    cumulative_count: previousCumulativeCount.toString(),
                });


            }


            // Update the previous cumulative count for the next iteration
            previousCumulativeCount = parseInt(currentRow.cumulative_count);
            newData.push(currentRow);
        }

        return newData;
    };


    return (
        <React.Fragment>
            <Box component="main" sx={{ flexGrow: 1, py: 8 }}>
                <Container maxWidth="lg">
                    <Stack spacing={3}>
                        <div>
                            <Typography variant="h4" fontWeight="bold">
                Product Metrics Dashboard
                            </Typography>
                        </div>
                    </Stack>
                </Container>
            </Box>

            <Box component="main" sx={{ flexGrow: 1, py: 8 }}>
                <Container maxWidth="xl">
                    { /* Add Form to select Name of the Institution, Year, and Month */ }
                    <form>
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel>Name of the Institution</InputLabel>
                                    <Select
                                        label="Name of the Institution"
                                        value={selectedInstitution}
                                        onChange={handleInstitutionChange}
                                    >
                                        { institutions.map((institution, index) => (
                                            <MenuItem key={index} value={institution}>
                                                { institution }
                                            </MenuItem>
                                        )) }
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </form>
                </Container>
            </Box>

            <Box component="main" sx={{ flexGrow: 1, py: 8 }}>
                <Container maxWidth="xl">
                    <Grid container spacing={3}>
                        { /* Card components for Published Activities, Unpublished Activities, Community Organizations, Units, Programs Initiatives, and Members */ }
                        <Box component="main" sx={{ flexGrow: 1, py: 8 }}>
                            <Container maxWidth="xl">
                                <Grid container spacing={3}>

                                    <Grid item xs={12} sm={6} md={4}>
                                        <Button onClick={handleCardClickPublishedActivities}>
                                            <Card variant="outlined" sx={{ height: '100%', backgroundColor: '#f1c40f' }} >
                                                <CardContent>
                                                    <Typography variant="h5" component="div">
                            Published Activities
                                                    </Typography>

                                                </CardContent>
                                            </Card>
                                        </Button>
                                    </Grid>


                                    <Grid item xs={12} sm={6} md={4}>
                                        <Button onClick={handleCardClickUnPublishedActivities}>
                                            <Card variant="outlined" sx={{ height: '100%' }}>
                                                <CardContent>
                                                    <Typography variant="h5" component="div">
                            Unpublished Activities
                                                    </Typography>

                                                </CardContent>
                                            </Card>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4}>
                                        <Button onClick={handleCardClickCommunityOrgs}>
                                            <Card variant="outlined" sx={{ height: '100%' }}>
                                                <CardContent>
                                                    <Typography variant="h5" component="div">
                            Community Organizations
                                                    </Typography>

                                                </CardContent>
                                            </Card>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4}>
                                        <Button onClick={handleCardClickUnits}>
                                            <Card variant="outlined" sx={{ height: '100%' }}>
                                                <CardContent>
                                                    <Typography variant="h5" component="div">
                            Units
                                                    </Typography>

                                                </CardContent>
                                            </Card>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4}>
                                        <Button onClick={handleCardClickProgramInitiatives}>
                                            <Card variant="outlined" sx={{ height: '100%' }}>
                                                <CardContent>
                                                    <Typography variant="h5" component="div">
                            Programs Initiatives
                                                    </Typography>

                                                </CardContent>
                                            </Card>
                                        </Button>
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4}>
                                        <Button>
                                            <Card variant="outlined" sx={{ height: '100%' }}>
                                                <CardContent>
                                                    <Typography variant="h5" component="div">
                            Members
                                                    </Typography>

                                                </CardContent>
                                            </Card>
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Container>
                        </Box>
                    </Grid>
                </Container>
            </Box>


            <DialogBox
                isOpen={isPublishedDialogOpen}
                onClose={handleClosePopup}
                title="Published Activities"
                activities={publishedActivities}
                isTableVisible={isTableVisible}
                isLineGraphVisible={isLineGraphVisible}
                toggleTable={toggleTable}
                toggleLineGraph={toggleLineGraph}
                setTableVisible={setTableVisible}
                setLineGraphVisible={setLineGraphVisible}
            />

            <DialogBox
                isOpen={isUnpublishedDialogOpen}
                onClose={handleClosePopup}
                title="Unpublished Activities"
                activities={unpublishedActivities}
                isTableVisible={isTableVisible}
                isLineGraphVisible={isLineGraphVisible}
                toggleTable={toggleTable}
                toggleLineGraph={toggleLineGraph}
                setTableVisible={setTableVisible}
                setLineGraphVisible={setLineGraphVisible}
            />

            <DialogBox
                isOpen={isCommunityOrgDialogOpen}
                onClose={handleClosePopup}
                title="Number of Community Partners"
                activities={communityOrgs}
                isTableVisible={isTableVisible}
                isLineGraphVisible={isLineGraphVisible}
                toggleTable={toggleTable}
                toggleLineGraph={toggleLineGraph}
                setTableVisible={setTableVisible}
                setLineGraphVisible={setLineGraphVisible}
            />

            <DialogBox
                isOpen={isUnitsDialogOpen}
                onClose={handleClosePopup}
                title="Number of Units"
                activities={units}
                isTableVisible={isTableVisible}
                isLineGraphVisible={isLineGraphVisible}
                toggleTable={toggleTable}
                toggleLineGraph={toggleLineGraph}
                setTableVisible={setTableVisible}
                setLineGraphVisible={setLineGraphVisible}
            />

            <DialogBox
                isOpen={isProgramInitiativesDialogOpen}
                onClose={handleClosePopup}
                title="Number of Program Initiatives"
                activities={programInitiatives}
                isTableVisible={isTableVisible}
                isLineGraphVisible={isLineGraphVisible}
                toggleTable={toggleTable}
                toggleLineGraph={toggleLineGraph}
                setTableVisible={setTableVisible}
                setLineGraphVisible={setLineGraphVisible}
            />


        </React.Fragment>
    );
};

export default Reports;

